import React from "react";
import Table from "../list/Table";
import { Link } from "react-router-dom";
import { IoMdPersonAdd } from "react-icons/io";
import { useTranslation } from "react-i18next";
import objectPath from "object-path";
import { API_ROOT } from "../defines";
import moment from "moment";
export const Permission = [
  {
    label: `行政`,
    // label: `Админ`,
    value: `admin`,
  },
  {
    label: `经理`,
    // label: `Менежер`,
    value: `manager`,
  },
  {
    label: `新闻经理`,
    // label: `Хэвлэлийн менежер`,
    value: `factory`,
  },
];
const List = () => {
  const { t } = useTranslation();
  return (
    <div className="flex flex-col ">
      <div className="flex items-center justify-between w-full h-20 py-3 px-8">
        <div className="text-xl font-semibold leading-5 text-black ">
          Хэрэглэгчид
        </div>
        <Link
          to={`new`}
          className="p-2 border-2 rounded hover:cursor-pointer border-primary"
        >
          <IoMdPersonAdd color="#1A2E55" />
        </Link>
      </div>
      <div className="px-4">
        <Table
          url={`/user/table`}
          sort={{ _id: -1 }}
          columns={[
            {
              label: t("user.email"),
              // label: `Хэрэглэгчийн нэр`,
              key: `email`,
              sort: true,
              filter: {
                type: "text",
              },
              render: ({ _id, email }) => {
                return (
                  <Link to={`view/${_id}`}>
                    <div className="text-primary underline font-semibold">
                      {email}
                    </div>
                  </Link>
                );
              },
            },

            {
              label: t("user.lastname"),
              // label: `Эцэг/эх/-ийн нэр`,
              key: `lastname`,
              sort: true,
              filter: {
                type: "text",
              },
            },
            {
              label: t("user.firstname"),
              // label: `Нэр`,
              key: `firstname`,
              sort: true,
              filter: {
                type: "text",
              },
            },

            {
              label: t("user.phone"),
              // label: `Утас`,
              key: `phone`,
              sort: true,
              filter: {
                type: "text",
              },
            },
            {
              label: t("user.role"),
              // label: `Системийн эрх`,
              key: `role`,
              sort: true,
              filter: {
                type: "select",
                items: Permission,
              },
              render: ({ role }) => {
                const temp = Permission.filter((row) => row.value == role);
                return <div>{temp[0]?.label}</div>;
              },
            },
            {
              label: t("createdby"),
              // label: `Бүртгэсэн`,
              key: `createdby.email`,
              sort: true,
              filter: {
                type: "text",
              },
            },
            {
              label: t("created"),
              // label: `Бүртгэсэн огноо`,
              key: `created`,
              sort: true,
              filter: {
                type: "text",
              },
              render: ({ created }) =>
                moment(created).format("YYYY-MM-DD HH:mm:ss"),
            },
          ]}
        />
      </div>
    </div>
  );
};

export default List;
